// import React, { useState, useEffect } from 'react'
// import { Link } from 'react-router-dom'
// import { FaArrowLeft, FaUser } from 'react-icons/fa'
// import bgimage from '../images/image-removebg-preview.png'
// import WhatappchatforArchive from './whatappchatforArchive'

// // --------- Helper functions similar to whatapplivechat.jsx ---------

// function decodeToken(token) {
//     if (!token) return {};
//     try {
//         const base64Url = token.split('.')[1]
//         const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
//         const jsonPayload = decodeURIComponent(
//             atob(base64)
//                 .split('')
//                 .map(function (c) {
//                     return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
//                 })
//                 .join('')
//         );
//         return JSON.parse(jsonPayload);
//     } catch (e) {
//         return {};
//     }
// }

// function getUserIdFromTokenOrLocatorgarsotrga() {
//     if (typeof window !== 'undefined' && typeof window.locatorgarsotrga === 'function') {
//         const rawToken = window.locatorgarsotrga("token");
//         if (rawToken) {
//             const decoded = decodeToken(rawToken);
//             const userId = decoded.id || decoded.userId || decoded._id;
//             return { userId, token: rawToken };
//         }
//     }
//     const rawToken = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
//     if (rawToken) {
//         const decoded = decodeToken(rawToken);
//         const userId = decoded.id || decoded.userId || decoded._id;
//         return { userId, token: rawToken };
//     }
//     return { userId: null, token: null };
// }

// // Determines if a DB message is incoming for selectedUser
// function isDbMessageIncoming(msg, selectedUser) {
//     if (!selectedUser) return false;
//     const userPhone = selectedUser.from_number;
//     if (!userPhone) return false;
//     if (msg.from_number === userPhone && !msg.to_number) return true;
//     if (!msg.from_number && msg.to_number === userPhone) return false;
//     return false;
// }

// // --------- Main Component ---------

// const UserChatArchive = () => {
//     const { userId, token } = getUserIdFromTokenOrLocatorgarsotrga();
//     const [phoneNumberId, setPhoneNumberId] = useState("");
//     const [messages, setMessages] = useState([]);
//     const [search, setSearch] = useState('');
//     const [selectedUser, setSelectedUser] = useState(null);

//     // Fetch phone number id for this user
//     useEffect(() => {
//         if (userId && token) {
//             fetch(`https://wa-api.globebot.io/auth/user/whatsapp-phone-numbers/${userId}`, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                 },
//             })
//                 .then(res => res.json())
//                 .then(data => {
//                     if (Array.isArray(data) && data[0]?.phone_number_id) {
//                         setPhoneNumberId(data[0].phone_number_id);
//                     }
//                 })
//                 .catch(err => {
//                     console.error('Could not fetch user data', err);
//                 });
//         }
//     }, [userId, token]);

//     // Fetch messages for current phone number id
//     useEffect(() => {
//         if (phoneNumberId) {
//             fetch(`https://wa-api.globebot.io/auth/messages/?phone_number_id=${phoneNumberId}`, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                 },
//             })
//                 .then(res => res.json())
//                 .then(data => {
//                     setMessages(Array.isArray(data) ? data : []);
//                 })
//                 .catch(err => {
//                     console.error('Could not fetch message data', err);
//                 });
//         }
//     }, [phoneNumberId, token]);

//     // Group conversations: one conversation per "from_number" (with incoming logic)
//     function groupConversationsWithIncoming(messages) {
//         const grouped = {};
//         messages.forEach(msg => {
//             // Identify the chat identifier
//             const key = msg.from_number || msg.to_number;
//             if (!key) return;

//             if (!grouped[key]) {
//                 grouped[key] = {
//                     from_number: key,
//                     phone_number_id: msg.phone_number_id,
//                     messages: [],
//                     lastMessage: '',
//                     lastTime: '',
//                     unread: 0,
//                 };
//             }
//             grouped[key].messages.push(msg);

//             // Last message display: show the latest message (either incoming or outgoing)
//             if (!grouped[key].lastTime || new Date(msg.created_at) > new Date(grouped[key].lastTime)) {
//                 grouped[key].lastMessage = msg.content;
//                 grouped[key].lastTime = msg.created_at;
//             }
//             // Count received + unread status, expand as needed
//             // Check for messages that are incoming only (from whatapplivechat.jsx logic)
//             if (isDbMessageIncoming(msg, { from_number: key })) {
//                 if (msg.status === 'received') {
//                     grouped[key].unread += 1;
//                 }
//             }
//         });

//         // Convert map to array
//         return Object.values(grouped);
//     }

//     // For truncated display of times
//     function timeString(iso) {
//         if (!iso) return "";
//         const dt = new Date(iso);
//         // Format as HH:mm (24hr)
//         return dt.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
//     }

//     // Filter and group conversations (using logic aligned with whatapplivechat.jsx)
//     const groupedChats = groupConversationsWithIncoming(messages);
//     const filteredChats = groupedChats.filter(chat =>
//         (chat.from_number || "").toLowerCase().includes(search.toLowerCase())
//     );

//     function findUser(number) {
//         const userChat = groupedChats.find(item => item.from_number === number);
//         if (userChat) setSelectedUser(userChat);
//     }

//     const colors = [
//         "bg-red-200",
//         "bg-green-200",
//         "bg-blue-200",
//         "bg-yellow-200",
//         "bg-purple-200",
//         "bg-pink-200",
//         "bg-indigo-200",
//     ];

//     // Handler to send a message
//     async function sendMessage({ to_number, message }) {
//         if (!token || !phoneNumberId || !to_number || !message) return;
//         try {
//             const response = await fetch('https://wa-api.globebot.io/auth/messages/send', {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                     'Authorization': `Bearer ${token}`,
//                 },
//                 body: JSON.stringify({
//                     phone_number_id: phoneNumberId,
//                     to_number: to_number,
//                     content: message,
//                 }),
//             });
//             if (!response.ok) throw new Error("Failed to send message");
//             const sentMsg = await response.json();
//             setMessages(prev => [...prev, sentMsg]);
//         } catch (error) {
//             console.error("Error sending message:", error);
//         }
//     }

//     // Make messages appear like WhatsApp: oldest first, not newest first
//     // Pass messages sorted this way to WhatappchatforArchive
//     function getSortedMessagesForSelectedUser(selectedUser) {
//         if (!selectedUser) return [];
//         // Combine sort by created_at asc (oldest first)
//         return [...selectedUser.messages].sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
//     }

//     return (
//         <>
//             <div className="flex min-h-screen bg-gray-100 pt-[100px] sm:pt-[50px]">

//                 {/* Sidebar */}
//                 <div className="w-[25%] bg-white  flex flex-col relative min-h-screen">

//                     {/* Header */}
//                     <div>
//                         <div className="flex items-center gap-4 p-4 chat-header">
//                             <Link to='/agents'>
//                                 <FaArrowLeft className="text-gray-700 cursor-pointer text-lg" />
//                             </Link>
//                             <div className="flex items-center gap-3 flex-1">
//                                 <div className="avatar flex items-center justify-center"><FaUser className="text-white text-2xl" /></div>
//                                 <div className="flex flex-col justify-center">
//                                     <span className="font-semibold text-gray-800 text-[16px] leading-4">
//                                         Business Name
//                                     </span>
//                                     <span className="text-xs text-[#7A91B7] pt-[2px]">All</span>
//                                 </div>
//                             </div>
//                         </div>
//                         {/* Filters */}
//                         <div className="flex gap-2 items-center p-4 pb-2 border-b-0 filter-section">
//                             {/* StyledInput */}
//                             <input
//                                 type="text"
//                                 placeholder="Search by number"
//                                 className="custom-select bg-white border border-[#E3EBF6] rounded-xl px-4 py-[7px] text-[15px] font-normal text-[#7A91B7] placeholder:text-[#7A91B7] outline-none w-full focus:border-[#6a5af9] transition-colors duration-100"
//                                 style={{ boxShadow: "none" }}
//                                 value={search}
//                                 onChange={(e) => setSearch(e.target.value)}
//                             />
//                         </div>
//                     </div>

//                     {/* Chat List */}
//                     <div className="w-[100%] h-[500px] overflow-scroll bg-transparent px-2 py-2">
//                         {filteredChats.length === 0 ? (
//                             <div className="flex items-center justify-center h-full text-[#7A91B7] text-base">
//                                 No chats found
//                             </div>
//                         ) : (
//                             filteredChats
//                                 .filter(chat => chat.from_number != null)
//                                 .map((chat, index) => (

//                                 <div
//                                     onClick={() => findUser(chat.from_number)}
//                                     key={chat.from_number}
//                                     className="flex items-center justify-between p-3 mb-2 bg-white rounded-lg shadow-sm hover:bg-gray-50 cursor-pointer"
//                                 >
//                                     {/* LEFT */}
//                                     <div className="flex items-center gap-3">
//                                         {/* Avatar */}
//                                         <div className="relative">
//                                             <div
//                                                 className={`w-12 h-12 flex items-center justify-center text-black font-bold rounded-xl uppercase ${colors[index % colors.length]}`}
//                                             >
//                                                 {String(chat.from_number).slice(-2)}
//                                             </div>
//                                             {/* Small icon */}
//                                             <div className="absolute bottom-0 right-0 bg-white border rounded-full p-[2px] shadow">
//                                                 <FaUser className="text-black text-[10px]" />
//                                             </div>
//                                         </div>
//                                         {/* Text */}
//                                         <div>
//                                             <h4 className="font-semibold text-sm uppercase">
//                                                 {chat.from_number}
//                                             </h4>
//                                             <p className="text-gray-500 text-sm truncate w-[160px]">
//                                                 {chat.lastMessage}
//                                             </p>
//                                         </div>
//                                     </div>
//                                     {/* RIGHT */}
//                                     <div className="text-xs text-gray-400 whitespace-nowrap">
//                                         {timeString(chat.lastTime)}
//                                     </div>
//                                 </div>
//                             ))
//                         )}
//                     </div>
//                 </div>

//                 {/* Main Content */}
//                 <div className="w-[75%] h-[100%] flex items-center justify-center ">
//                     {selectedUser ? (
//                         <WhatappchatforArchive
//                             selectedUser={{
//                                 ...selectedUser,
//                                 // always provide messages oldest-to-newest as WhatsApp does
//                                 messages: getSortedMessagesForSelectedUser(selectedUser),
//                             }}
//                             sendMessage={sendMessage}
//                             currentPhoneNumberId={phoneNumberId}
//                         />
//                     ) : (
//                         <div className='w-[100%] flex justify-center items-center min-h-screen'>
//                             <img
//                                 src={bgimage}
//                                 alt="illustration"
//                                 className="w-[400px]"
//                             />
//                         </div>
//                     )}
//                 </div>
//             </div>
//         </>
//     )
// }

// export default UserChatArchive
import React, { useState, useEffect, useRef, useCallback } from 'react'
import { Link } from 'react-router-dom'
import { FaArrowLeft, FaUser } from 'react-icons/fa'
import { FaUserPlus, FaUserMinus, FaChevronDown, FaCheck } from 'react-icons/fa6'
import bgimage from '../images/image-removebg-preview.png'
import WhatappchatforArchive from './whatappchatforArchive'

// ─── JWT helpers ──────────────────────────────────────────────────────────────

function decodeToken(token) {
    if (!token) return {};
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64).split('').map(c => `%${('00' + c.charCodeAt(0).toString(16)).slice(-2)}`).join('')
        );
        return JSON.parse(jsonPayload);
    } catch { return {}; }
}

function getUserIdFromTokenOrLocatorgarsotrga() {
    if (typeof window !== 'undefined' && typeof window.locatorgarsotrga === 'function') {
        const rawToken = window.locatorgarsotrga("token");
        if (rawToken) {
            const decoded = decodeToken(rawToken);
            return { userId: decoded.id || decoded.userId || decoded._id, token: rawToken };
        }
    }
    const rawToken = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
    if (rawToken) {
        const decoded = decodeToken(rawToken);
        return { userId: decoded.id || decoded.userId || decoded._id, token: rawToken };
    }
    return { userId: null, token: null };
}

function isDbMessageIncoming(msg, selectedUser) {
    if (!selectedUser) return false;
    const userPhone = selectedUser.from_number;
    if (!userPhone) return false;
    if (msg.from_number === userPhone && !msg.to_number) return true;
    if (!msg.from_number && msg.to_number === userPhone) return false;
    return false;
}

// ─── Template preview helper ──────────────────────────────────────────────────
// Returns a clean single-line string for sidebar previews and last message display.
// Handles: plain text, template JSON objects, stringified JSON.

function getMessagePreview(content) {
    if (!content) return '';

    try {
        const parsed = typeof content === 'string' ? JSON.parse(content) : content;

        if (parsed?.name && parsed?.language !== undefined) {
            // It's a WhatsApp template object
            const bodyComp = parsed.components?.find(
                c => (c.type || '').toLowerCase() === 'body'
            );
            const params   = bodyComp?.parameters || [];
            let bodyText   = bodyComp?.text || '';

            // Substitute {{1}}, {{2}} … with actual param values
            params.forEach((param, i) => {
                bodyText = bodyText.replace(
                    new RegExp(`\\{\\{${i + 1}\\}\\}`, 'g'),
                    param.text || param.payload || ''
                );
            });

            if (bodyText) return `📋 ${bodyText}`;

            // Fallback: show param values if no body text stored
            const paramValues = params.map(p => p.text || p.payload).filter(Boolean).join(', ');
            if (paramValues) return `📋 ${paramValues}`;

            // Last resort: just show template name
            return `📋 Template: ${parsed.name}`;
        }
    } catch {
        // Not JSON — plain text, fall through
    }

    return content;
}

// ─── Assign Agent Dropdown ────────────────────────────────────────────────────

function AssignAgentPanel({ agents, currentAssignment, onAssign, onUnassign, assigning }) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        function handleClick(e) {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        }
        document.addEventListener('mousedown', handleClick);
        return () => document.removeEventListener('mousedown', handleClick);
    }, []);

    const isAssigned = currentAssignment?.status === 'assigned' && currentAssignment?.agent_id;

    return (
        <div className="relative hidden" ref={ref}>
            <button
                onClick={() => setOpen(o => !o)}
                disabled={assigning}
                className={`flex items-center gap-2 px-3 py-1.5 rounded-xl text-[13px] font-semibold border transition-all duration-200
                    ${isAssigned
                        ? 'bg-[#e8f8f2] border-[#16D39A] text-[#37715d] hover:bg-[#d0f0e4]'
                        : 'bg-[#f0f4ff] border-[#6a5af9] text-[#6a5af9] hover:bg-[#e4e0ff]'
                    } ${assigning ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer'}`}
            >
                {assigning ? (
                    <span className="w-3.5 h-3.5 border-2 border-current border-t-transparent rounded-full animate-spin" />
                ) : isAssigned ? (
                    <FaCheck className="text-[11px]" />
                ) : (
                    <FaUserPlus className="text-[13px]" />
                )}
                <span className="max-w-[110px] truncate">
                    {isAssigned ? currentAssignment.agent_name || 'Assigned' : 'Assign Agent'}
                </span>
                <FaChevronDown className={`text-[10px] transition-transform duration-200 ${open ? 'rotate-180' : ''}`} />
            </button>

            {open && (
                <div className="absolute right-0 top-full mt-2 w-[220px] bg-white rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.12)] border border-[#f0f4ff] z-[100] overflow-hidden">
                    <div className="px-4 py-3 bg-[#f8faff] border-b border-[#eef1f8]">
                        <p className="text-[11px] uppercase font-bold tracking-wider text-[#94a3b8]">Assign to Agent</p>
                        {isAssigned && (
                            <p className="text-[12px] text-[#37715d] font-semibold mt-0.5 truncate">
                                ✓ {currentAssignment.agent_name}
                            </p>
                        )}
                    </div>

                    <div className="max-h-[200px] overflow-y-auto py-1">
                        {agents.length === 0 ? (
                            <div className="px-4 py-3 text-[12px] text-[#94a3b8] text-center">No agents available</div>
                        ) : (
                            agents.map(agent => {
                                const isThis = currentAssignment?.agent_id === agent.id && isAssigned;
                                return (
                                    <button
                                        key={agent.id}
                                        onClick={() => { onAssign(agent); setOpen(false); }}
                                        className={`w-full flex items-center gap-3 px-4 py-2.5 text-left transition-colors duration-100
                                            ${isThis ? 'bg-[#e8f8f2]' : 'hover:bg-[#f8faff]'}`}
                                    >
                                        <div className={`w-8 h-8 rounded-xl flex items-center justify-center text-[11px] font-bold uppercase
                                            ${isThis ? 'bg-[#16D39A] text-white' : 'bg-[#e8edf8] text-[#6a5af9]'}`}>
                                            {agent.name?.slice(0, 2) || 'AG'}
                                        </div>
                                        <div className="flex-1 min-w-0">
                                            <p className={`text-[13px] font-semibold truncate ${isThis ? 'text-[#37715d]' : 'text-[#27446b]'}`}>
                                                {agent.name}
                                            </p>
                                            <p className="text-[11px] text-[#94a3b8] truncate">{agent.email}</p>
                                        </div>
                                        {isThis && <FaCheck className="text-[#16D39A] text-[11px] flex-shrink-0" />}
                                    </button>
                                );
                            })
                        )}
                    </div>

                    {isAssigned && (
                        <div className="border-t border-[#eef1f8] p-2">
                            <button
                                onClick={() => { onUnassign(); setOpen(false); }}
                                className="w-full flex items-center gap-2 px-3 py-2 rounded-xl text-[12px] font-semibold text-red-400 hover:bg-red-50 transition-colors duration-100"
                            >
                                <FaUserMinus className="text-[13px]" />
                                Unassign Agent
                            </button>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

// ─── Assignment Badge ─────────────────────────────────────────────────────────

function AssignmentBadge({ agentName }) {
    if (!agentName) return null;
    return (
        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-[#e8f8f2] text-[#37715d] text-[10px] font-semibold border border-[#c3edd9] max-w-[90px] truncate">
            <span className="w-1.5 h-1.5 rounded-full bg-[#16D39A] flex-shrink-0" />
            <span className="truncate">{agentName}</span>
        </span>
    );
}

// ─── Main Component ───────────────────────────────────────────────────────────

const UserChatArchive = () => {
    const { userId, token } = getUserIdFromTokenOrLocatorgarsotrga();
    const [phoneNumberId, setPhoneNumberId] = useState("");
    const [messages, setMessages] = useState([]);
    const [search, setSearch] = useState('');
    const [selectedUser, setSelectedUser] = useState(null);

    // ── Agent assignment state ────────────────────────────────────────────────
    const [agents, setAgents] = useState([]);
    const [assignmentMap, setAssignmentMap] = useState({});
    const [currentAssignment, setCurrentAssignment] = useState(null);
    const [assigning, setAssigning] = useState(false);

    // Fetch phone number id
    useEffect(() => {
        if (userId && token) {
            fetch(`https://wa-api.globebot.io/auth/user/whatsapp-phone-numbers/${userId}`, {
                headers: { 'Authorization': `Bearer ${token}` },
            })
                .then(res => res.json())
                .then(data => {
                    if (Array.isArray(data) && data[0]?.phone_number_id) {
                        setPhoneNumberId(data[0].phone_number_id);
                    }
                })
                .catch(err => console.error('Could not fetch user data', err));
        }
    }, [userId, token]);

    // Fetch messages
    useEffect(() => {
        if (phoneNumberId) {
            fetch(`https://wa-api.globebot.io/auth/messages/?phone_number_id=${phoneNumberId}`, {
                headers: { 'Authorization': `Bearer ${token}` },
            })
                .then(res => res.json())
                .then(data => setMessages(Array.isArray(data) ? data : []))
                .catch(err => console.error('Could not fetch message data', err));
        }
    }, [phoneNumberId, token]);

    // Fetch agents list
    useEffect(() => {
        if (!userId || !token) return;
        fetch(`https://wa-api.globebot.io/auth/agents/by-account?user_id=${userId}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
            .then(r => r.json())
            .then(data => { if (data.success) setAgents(data.data); })
            .catch(console.error);
    }, [userId, token]);

    // Fetch bulk assignment map
    useEffect(() => {
        if (!phoneNumberId || !token) return;
        fetch(`https://wa-api.globebot.io/auth/chat-assignments/bulk?phone_number_id=${phoneNumberId}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
            .then(r => r.json())
            .then(data => { if (data.success) setAssignmentMap(data.data); })
            .catch(console.error);
    }, [phoneNumberId, token]);

    // Fetch assignment for selected user
    useEffect(() => {
        if (!selectedUser || !phoneNumberId || !token) { setCurrentAssignment(null); return; }
        fetch(`https://wa-api.globebot.io/auth/chat-assignment?phone_number_id=${phoneNumberId}&customer_number=${selectedUser.from_number}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
            .then(r => r.json())
            .then(data => { if (data.success) setCurrentAssignment(data.data); })
            .catch(console.error);
    }, [selectedUser, phoneNumberId, token]);

    // Assign handler
    const handleAssign = useCallback(async (agent) => {
        if (!selectedUser || !phoneNumberId) return;
        setAssigning(true);
        try {
            const res = await fetch('https://wa-api.globebot.io/auth/assign-chat', {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    phone_number_id: phoneNumberId,
                    customer_number: selectedUser.from_number,
                    agent_id: agent.id,
                    assigned_by: userId,
                })
            });
            const data = await res.json();
            if (data.success) {
                const newAssignment = { agent_id: agent.id, agent_name: agent.name, status: 'assigned', assigned_at: new Date().toISOString() };
                setCurrentAssignment(newAssignment);
                setAssignmentMap(prev => ({
                    ...prev,
                    [selectedUser.from_number]: { ...newAssignment, customer_number: selectedUser.from_number }
                }));
            }
        } catch (err) {
            console.error('Assign error:', err);
        } finally {
            setAssigning(false);
        }
    }, [selectedUser, phoneNumberId, token, userId]);

    // Unassign handler
    const handleUnassign = useCallback(async () => {
        if (!selectedUser || !phoneNumberId) return;
        setAssigning(true);
        try {
            const res = await fetch('https://wa-api.globebot.io/auth/unassign-chat', {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                body: JSON.stringify({ phone_number_id: phoneNumberId, customer_number: selectedUser.from_number })
            });
            const data = await res.json();
            if (data.success) {
                setCurrentAssignment(null);
                setAssignmentMap(prev => {
                    const next = { ...prev };
                    delete next[selectedUser.from_number];
                    return next;
                });
            }
        } catch (err) {
            console.error('Unassign error:', err);
        } finally {
            setAssigning(false);
        }
    }, [selectedUser, phoneNumberId, token]);

    // ── Chat grouping ─────────────────────────────────────────────────────────
    function groupConversationsWithIncoming(messages) {
        const grouped = {};
        messages.forEach(msg => {
            const key = msg.from_number || msg.to_number;
            if (!key) return;
            if (!grouped[key]) {
                grouped[key] = {
                    from_number: key,
                    profileName: msg.profileName || null,  // ✅ capture it
                    phone_number_id: msg.phone_number_id,
                    messages: [],
                    lastMessage: '',
                    lastTime: '',
                    unread: 0,
                };
            }
            // ✅ update if a later message has it
            if (msg.profileName && !grouped[key].profileName) {
                grouped[key].profileName = msg.profileName;
            }
            grouped[key].messages.push(msg);
            if (!grouped[key].lastTime || new Date(msg.created_at) > new Date(grouped[key].lastTime)) {
                grouped[key].lastMessage = getMessagePreview(msg.content);
                grouped[key].lastTime    = msg.created_at;
            }
            if (isDbMessageIncoming(msg, { from_number: key }) && msg.status === 'received') {
                grouped[key].unread += 1;
            }
        });
        return Object.values(grouped);
    }

    function timeString(iso) {
        if (!iso) return "";
        return new Date(iso).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }

    const groupedChats   = groupConversationsWithIncoming(messages);
    const filteredChats  = groupedChats.filter(chat =>
        (chat.from_number || "").toLowerCase().includes(search.toLowerCase())
    );

    function findUser(number) {
        const userChat = groupedChats.find(item => item.from_number === number);
        if (userChat) setSelectedUser(userChat);
    }

    async function sendMessage({ to_number, message }) {
        if (!token || !phoneNumberId || !to_number || !message) return;
        try {
            const response = await fetch('https://wa-api.globebot.io/auth/messages/send', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify({ phone_number_id: phoneNumberId, to_number, content: message }),
            });
            if (!response.ok) throw new Error("Failed to send message");
            const sentMsg = await response.json();
            setMessages(prev => [...prev, sentMsg]);
        } catch (error) {
            console.error("Error sending message:", error);
        }
    }

    function getSortedMessagesForSelectedUser(selectedUser) {
        if (!selectedUser) return [];
        return [...selectedUser.messages].sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
    }

    const colors = ["bg-red-200", "bg-green-200", "bg-blue-200", "bg-yellow-200", "bg-purple-200", "bg-pink-200", "bg-indigo-200"];

    return (
        <div className="flex min-h-screen bg-gray-100 pt-[100px] sm:pt-[50px]">

            {/* ── Sidebar ───────────────────────────────────────────────────── */}
            <div className="w-[25%] bg-white flex flex-col relative min-h-screen">
                <div>
                    <div className="flex items-center gap-4 p-4 chat-header">
                        <Link to='/agents'>
                            <FaArrowLeft className="text-gray-700 cursor-pointer text-lg" />
                        </Link>
                        <div className="flex items-center gap-3 flex-1">
                            <div className="avatar flex items-center justify-center">
                                <FaUser className="text-white text-2xl" />
                            </div>
                            <div className="flex flex-col justify-center">
                                <span className="font-semibold text-gray-800 text-[16px] leading-4">Business Name</span>
                                <span className="text-xs text-[#7A91B7] pt-[2px]">Archive</span>
                            </div>
                        </div>
                    </div>

                    <div className="flex gap-2 items-center p-4 pb-2 border-b-0 filter-section">
                        <input
                            type="text"
                            placeholder="Search by number"
                            className="custom-select bg-white border border-[#E3EBF6] rounded-xl px-4 py-[7px] text-[15px] font-normal text-[#7A91B7] placeholder:text-[#7A91B7] outline-none w-full focus:border-[#6a5af9] transition-colors duration-100"
                            style={{ boxShadow: "none" }}
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                        />
                    </div>
                </div>

                {/* Contact list */}
                <div className="w-full h-[500px] overflow-scroll bg-transparent px-2 py-2">
                    {filteredChats.length === 0 ? (
                        <div className="flex items-center justify-center h-full text-[#7A91B7] text-base">No chats found</div>
                    ) : (
                        filteredChats
                            .filter(chat => chat.from_number != null)
                            .map((chat, index) => {
                                const assignment = assignmentMap[chat.from_number];
                                const isSelected = selectedUser?.from_number === chat.from_number;
                                return (
                                    <div
                                        onClick={() => findUser(chat.from_number)}
                                        key={chat.from_number}
                                        className={`flex items-center justify-between p-3 mb-2 rounded-lg shadow-sm cursor-pointer transition-all duration-150
                                            ${isSelected ? 'bg-[#f0fdf8] border border-[#c3edd9]' : 'bg-white hover:bg-gray-50'}`}
                                    >
                                        <div className="flex items-center gap-3 min-w-0 flex-1">
                                            <div className="relative flex-shrink-0">
                                                <div className={`w-12 h-12 flex items-center justify-center text-black font-bold rounded-xl uppercase ${colors[index % colors.length]}`}>
                                                    {String(chat.from_number).slice(-2)}
                                                </div>
                                                {assignment?.status === 'assigned' && (
                                                    <span className="absolute -bottom-0.5 -right-0.5 w-3.5 h-3.5 bg-[#16D39A] border-2 border-white rounded-full" />
                                                )}
                                                <div className="absolute bottom-0 right-0 bg-white border rounded-full p-[2px] shadow">
                                                    <FaUser className="text-black text-[10px]" />
                                                </div>
                                            </div>
                                            <div className="min-w-0 flex-1">
    {/* ✅ Show profileName as primary, number below if name exists */}
    <h4 className="font-semibold text-sm">
        {chat.profileName || chat.from_number}
    </h4>
    {chat.profileName && (
        <p className="text-[#94a3b8] text-[11px] font-medium leading-none mb-0.5">
            {chat.from_number}
        </p>
    )}
                                                {assignment?.status === 'assigned' && (
                                                    <AssignmentBadge agentName={assignment.agent_name} />
                                                )}
                                                {/* ✅ lastMessage is now already a clean preview string */}
                                                <p className="text-gray-500 text-xs truncate w-[130px] mt-0.5">
                                                    {chat.lastMessage}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="text-xs text-gray-400 whitespace-nowrap ml-2 flex-shrink-0">
                                            {timeString(chat.lastTime)}
                                        </div>
                                    </div>
                                );
                            })
                    )}
                </div>
            </div>

            {/* ── Main Content ──────────────────────────────────────────────── */}
            <div className="w-[75%] h-full flex flex-col">

                {/* Assign agent header bar */}
                {selectedUser && (
                    <div className="flex items-center justify-between px-5 py-3 bg-white border-b border-[#eef1f8] shadow-sm z-10">
                        <div className="flex items-center gap-3">
                            <div className={`w-9 h-9 rounded-xl flex items-center justify-center text-[12px] font-bold uppercase ${colors[0]}`}>
                                {String(selectedUser.profileName).slice(-2)}
                            </div>
                            <div>
                                <p className="font-semibold text-[14px] text-[#27446b]">{selectedUser.profileName}</p>
                                <p className="text-[11px] text-[#94a3b8]">
                                    {currentAssignment?.status === 'assigned'
                                        ? `Assigned to ${currentAssignment.agent_name}`
                                        : 'Unassigned'
                                    }
                                </p>
                            </div>
                        </div>

                        <AssignAgentPanel
                            agents={agents}
                            currentAssignment={currentAssignment}
                            onAssign={handleAssign}
                            onUnassign={handleUnassign}
                            assigning={assigning}
                        />
                    </div>
                )}

                {/* Chat area */}
                <div className="flex-1 flex items-center justify-center">
                    {selectedUser ? (
                        <WhatappchatforArchive
                            selectedUser={{
                                ...selectedUser,
                                messages: getSortedMessagesForSelectedUser(selectedUser),
                            }}
                            sendMessage={sendMessage}
                            currentPhoneNumberId={phoneNumberId}
                        />
                    ) : (
                        <div className='w-full flex justify-center items-center min-h-screen'>
                            <img src={bgimage} alt="illustration" className="w-[400px]" />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default UserChatArchive;